import comunidadesRoutes from '@/modules/mobile/comunidades/routes'

const breadcrumbsHome = { name: 'Home', pathName: '/home', onlyAvailableOnVue2: true }
const breadcrumbsMobile = { name: 'Mobile', pathName: null }

export default [
  ...comunidadesRoutes,
  {
    path: '/mobile',
    component: () => import('@/views/BaseRoutingComponent.vue'),
    children: [
      {
        path: 'ofertas',
        title: 'Ofertas do aplicativo',
        component: () => import('@/modules/mobile/ofertas/views/pages/Ofertas.vue'),
        meta: {
          title: 'Ofertas do aplicativo',
          requiredModules: ['mobile'],
        },
        children: [
          {
            path: '',
            redirect: { name: 'mobile-ofertas-produtos-edicao' },
          },
          {
            path: 'produtos',
            redirect: { name: 'mobile-ofertas-produtos-edicao' },
          },
          {
            path: 'produtos/edicao',
            name: 'mobile-ofertas-produtos-edicao',
            component: () => import('@/modules/mobile/ofertas/views/pages/Produtos.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Ofertas do aplicativo',
                  pathName: null,
                },
              ],
              requiredModules: ['mobile'],
              title: 'Ofertas do aplicativo',
              requiredUserPermissions: ['mobile/ofertas/produtos/edicao'],
            },
          },
          {
            path: 'produtos/edicao-lojas-franquia',
            component: () => import('@/modules/mobile/ofertas/views/pages/Produtos.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Ofertas do aplicativo',
                  pathName: null,
                },
              ],
              requiredModules: ['mobile'],
              title: 'Ofertas do aplicativo',
              requiredUserPermissions: ['mobile/ofertas/produtos/edicao-lojas-franquia'],
            },
          },
          {
            path: 'destaques',
            component: () => import('@/modules/mobile/ofertas/views/pages/Destaques.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Ofertas do aplicativo',
                  pathName: null,
                },
              ],
              requiredModules: ['mobile'],
              requiredUserPermissions: ['mobile/ofertas/destaques'],
              title: 'Ofertas em destaque',
            },
          },
          {
            path: 'destaques/editar/:type',
            component: () => import('@/modules/mobile/ofertas/views/pages/EditarDestaques.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Ofertas do aplicativo',
                  pathName: null,
                },
              ],
              requiredModules: ['mobile'],
              requiredUserPermissions: ['mobile/ofertas/destaques'],
              title: 'Ofertas em destaque',
            },
          },
        ],
      },
      {
        path: 'desempenho',
        component: () => import('@/modules/mobile/desempenho/views/pages/Index.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMobile,
            {
              name: 'Desempenho',
              pathName: null,
            },
          ],
          title: 'Desempenho',
          requiredModules: ['mobile'],
          requiredUserPermissions: ['mobile/desempenho'],
        },
      },
      {
        path: 'encartes',
        component: () => import('@/views/BaseRoutingComponent.vue'),
        children: [
          {
            path: '',
            component: () => import('@/modules/mobile/encartes/views/pages/Encartes.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Encartes',
                  pathName: null,
                },
              ],
              title: 'Encartes',
              requiredModules: ['mobile', 'chatbot'],
              requiredUserPermissions: ['mobile/encartes'],
            },
          },
          {
            path: 'novo',
            component: () => import('@/modules/mobile/encartes/views/pages/AlteracaoEncartes.vue'),
            props: { newCampaign: true },
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Encartes',
                  pathName: '/mobile/encartes',
                },
                {
                  name: 'Novo encarte',
                  pathName: null,
                },
              ],
              title: 'Encartes',
              requiredModules: ['mobile', 'chatbot'],
              requiredUserPermissions: ['mobile/encartes'],
            },
          },
          {
            path: 'editar/:id',
            name: 'encartes-edit',
            component: () => import('@/modules/mobile/encartes/views/pages/AlteracaoEncartes.vue'),
            props: { newCampaign: false },
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Encartes',
                  pathName: '/mobile/encartes',
                },
                {
                  name: 'Editar encarte',
                  pathName: null,
                },
              ],
              title: 'Encartes',
              requiredModules: ['mobile', 'chatbot'],
              requiredUserPermissions: ['mobile/encartes'],
            },
          },
          {
            path: 'visualizar/:id',
            component: () => import('@/modules/mobile/encartes/views/pages/AlteracaoEncartes.vue'),
            props: { newCampaign: false, readOnly: true },
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Encartes',
                  pathName: '/mobile/encartes',
                },
                {
                  name: 'Visualizar encarte',
                  pathName: null,
                },
              ],
              title: 'Encartes',
              requiredModules: ['mobile', 'chatbot'],
              requiredUserPermissions: ['mobile/encartes'],
            },
          },
          {
            path: 'resultados/:id',
            name: 'encartes-resultados',
            component: () => import('@/modules/mobile/encartes/views/pages/ResultadosEncarte.vue'),
            meta: {
              breadcrumbs: [
                breadcrumbsHome,
                breadcrumbsMobile,
                {
                  name: 'Encartes',
                  pathName: '/mobile/encartes',
                },
                {
                  name: 'Resultados do encarte',
                  pathName: null,
                },
              ],
              title: 'Encartes',
              requiredModules: ['mobile', 'chatbot'],
              requiredUserPermissions: ['mobile/encartes'],
            },
          },
        ],
      },
    ],
  },
]
